import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import deepEqual from "fast-deep-equal";
import { extractAssetId, isTemplateTableId } from "../utils";
import { zslAtom } from "../templates";
import { aiSuggestedEditsAtomFamily } from "../nodes";

export const tableFieldsFromZslAtomFamily = atomFamily(
  ({
    tableId,
    proposalId,
    nodeId,
  }: {
    nodeId: string;
    tableId: string | undefined;
    proposalId: string | undefined;
  }) => {
    const baseAtom = atom((get) => {
      if (!tableId && !proposalId) {
        return;
      }
      // if proposalId is provided, we are using the ai suggested edits and it is a template table
      const isTemplateTable = isTemplateTableId(tableId) || proposalId;

      if (isTemplateTable) {
        const aiProposedEdits = get(aiSuggestedEditsAtomFamily(nodeId));
        const zsl = get(zslAtom);

        if (aiProposedEdits && proposalId) {
          const aiProposed = aiProposedEdits.additions.find(
            (addition) => addition.id === proposalId,
          );
          if (aiProposed) {
            if (aiProposed.zsl?.tables) {
              return aiProposed.zsl.tables[0].fields;
            }
            if (aiProposed.outline?.tables?.[0]?.tables?.[0]?.fields) {
              return aiProposed.outline.tables[0].tables[0].fields;
            }
          }
        }

        if (zsl && tableId) {
          const coreTableId = extractAssetId(tableId);
          const tableTemplate = zsl.tables?.find(
            (table) => coreTableId === table.id,
          );

          if (tableTemplate) {
            return tableTemplate.fields;
          }
        }
      }
    });

    baseAtom.debugLabel = `tableFieldsFromZslAtomFamily(${tableId})-nodeId:${nodeId})-proposalId:${proposalId}`;
    return baseAtom;
  },
  deepEqual,
);
